import { Stack, useMediaQuery, useTheme } from "@mui/material";
import Header from "../components/Header";
import BrickWorkingReportMobileComponent from "./../components/mobile/bricks-working-report/BrickWorkingReportMobileComponent";
import BrickWorkingReportDesktop from "../components/desktop/brick-management-report/BrickManagementReportDesktop";

type Props = {};

const BrickWorkingReport = (props: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack p={1} gap={2}>
      {/* <Header title="Brick Working Report" /> */}
      {/* {isMobile ? (
        <BrickWorkingReportMobileComponent />
      ) : ( */}
        <BrickWorkingReportDesktop />
      {/* )} */}
    </Stack>
  );
};

export default BrickWorkingReport;
